module.exports = __webpack_public_path__ + "img/5.1fd46bb6.png";